import axios from 'axios';
import {
  CreateUserRequest,
  GetUserResponse,
  LoginRequest,
  LoginResponse,
  PasswordRecoveryRequest,
  PasswordResetRequest,
} from './dto/users.dto';

class UsersApi {
  async login(loginRequest: LoginRequest): Promise<LoginResponse> {
    return (await axios.post('/users/login', loginRequest)).data;
  }

  async createUser(request: CreateUserRequest): Promise<LoginResponse> {
    return (await axios.post('/users', request)).data;
  }

  async passwordRecovery(request: PasswordRecoveryRequest) {
    await axios.post('/users/password/recovery', request);
  }

  async passwordReset(request: PasswordResetRequest) {
    await axios.post('/users/password/reset', request);
  }

  async completeTutorial() {
    await axios.put('/users/tutorial/complete');
  }

  async getUser(): Promise<GetUserResponse> {
    return (await axios.get('/users/me')).data;
  }
}

export default new UsersApi();
